import BaseLayout from './component'

export default BaseLayout
